// removed by extract-text-webpack-plugin
module.exports = {"hidden":"SPBtV","visuallyhidden":"_2bJXd","hide-text":"_1M6b2","center":"_3oOiE","noprint":"_3-EPx","coreNavigation":"_1K9_6"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/styles/components/CoreNavigation.scss
 ** module id = 959
 ** module chunks = 1
 **/